"use strict";
exports.VERSION = '2.1.1';
//# sourceMappingURL=SearchkitVersion.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/searchkit/lib/src/core/SearchkitVersion.js
// module id = 205
// module chunks = 0